import fetch from 'isomorphic-fetch';

import { updateTriggers } from 'actions/triggers';
import { HEADER_CONTENT_TYPE } from 'constants/http';
import { JSON as JSON_MIME } from 'constants/mimes';
import { ALL as ALL_TRIGGERS } from 'constants/triggers';
import * as sentry from 'utilities/sentry';

import {
  isTriggerComplete,
  shouldShowTrigger,
} from '../../../shared/utilities/triggers';

export function completeTriggerCreator(triggerName) {
  return (dispatch, getState) => {
    if (!ALL_TRIGGERS.includes(triggerName)) {
      sentry.logException(
        new Error('invalid trigger name'),
        'tried to complete invalid trigger',
        { triggerName }
      );

      return;
    }

    const { triggers } = getState().triggers;

    // don't complete if already complete
    if (isTriggerComplete(triggers, triggerName)) {
      return;
    }

    const completeTrigger = {
      [triggerName]: {
        complete: true,
        show: false,
      },
    };

    const newTriggers = Object.assign({}, triggers, completeTrigger);

    dispatch(updateTriggers(newTriggers));

    const body = JSON.stringify({
      triggers: completeTrigger,
    });

    return fetch('/v1/users/', {
      method: 'PATCH',
      credentials: 'include',
      headers: { [HEADER_CONTENT_TYPE]: JSON_MIME },
      body,
    });
  };
}

export function activateTriggerCreator(triggerName) {
  return (dispatch, getState) => {
    if (!ALL_TRIGGERS.includes(triggerName)) {
      sentry.logException(
        new Error('invalid trigger name'),
        'tried to activate invalid trigger',
        { triggerName }
      );

      return;
    }

    const { triggers } = getState().triggers;

    // don't activate if already active
    if (shouldShowTrigger(triggers, triggerName)) {
      return;
    }

    const activeTrigger = {
      [triggerName]: {
        complete: false,
        show: true,
      },
    };

    const newTriggers = Object.assign({}, triggers, activeTrigger);

    dispatch(updateTriggers(newTriggers));

    const body = JSON.stringify({
      triggers: activeTrigger,
    });

    return fetch('/v1/users/', {
      method: 'PATCH',
      credentials: 'include',
      headers: { [HEADER_CONTENT_TYPE]: JSON_MIME },
      body,
    });
  };
}
